import { TYPE_SIZES as i } from "../../utils/index.js";
import { openBlock as r, createElementBlock as m, normalizeClass as d, createElementVNode as a, withModifiers as n, withDirectives as f, withKeys as o, vModelText as b } from "vue";
import "./index2.js";
import h from "../../_virtual/index.js";
const v = {
  name: "Counter",
  model: {
    prop: "values",
    event: "change"
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    size: {
      type: String,
      default: i.normal.value
    },
    values: {
      type: Number,
      default: 1
    },
    maxValue: {
      type: Number,
      default: 999
    },
    minValue: {
      type: Number,
      default: 0
    },
    isAllowZero: {
      type: Boolean,
      default: !1
    },
    isDisabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "change",
    "update:modelValue",
    "on-focus",
    "on-blur",
    "on-minus",
    "on-plus"
  ],
  data: (e) => ({
    value: e.values,
    focus: !1
  }),
  computed: {
    classes() {
      return {
        [i.small.className]: this.size === i.small.value,
        [i.large.className]: this.size === i.large.value
      };
    }
  },
  watch: {
    values(e, t) {
      e !== t && this.setValue(Number(e));
    },
    modelValue(e, t) {
      e !== t && this.setValue(Number(e));
    }
  },
  methods: {
    onAction(e) {
      const t = this.value;
      switch (e) {
        case "minus": {
          this.$emit("on-minus"), this.setValue(t - 1);
          break;
        }
        case "plus": {
          this.$emit("on-plus"), this.setValue(t + 1);
          break;
        }
      }
    },
    onInput({ target: e }) {
      this.focus && e.value !== "" && this.setValue(Number(e.value));
    },
    onBlur(e) {
      this.$emit("on-blur", e), this.focus = !1, e.target.value === "" && this.setValue(this.isAllowZero ? 0 : this.value);
    },
    onFocus(e) {
      this.$emit("on-focus", e), this.focus = !0;
    },
    setValue(e) {
      e <= this.minValue ? this.value = e === 0 && this.isAllowZero ? 0 : this.minValue : e === 0 && this.isAllowZero ? this.value = 0 : e >= this.maxValue ? this.value = this.maxValue : this.value = e, this.$emit("change", this.value), this.$emit("update:modelValue", this.value);
    },
    valueMask(e) {
      const t = e.which || e.button;
      if (e.ctrlKey && t === 86)
        return !1;
      e.charCode && (e.charCode < 48 || e.charCode > 57) && (e.returnValue = !1);
    }
  }
}, p = ["disabled"], V = { class: "b24-counter__input-box" }, c = ["disabled"], y = ["disabled"];
function w(e, t, u, k, N, s) {
  return r(), m("div", {
    class: d(["b24-counter", s.classes])
  }, [
    a("button", {
      class: "b24-counter__button _minus",
      type: "button",
      disabled: e.value <= u.minValue || u.isDisabled,
      onClick: t[0] || (t[0] = n((l) => s.onAction("minus"), ["prevent"]))
    }, " \u2212 ", 8, p),
    a("label", V, [
      f(a("input", {
        ref: "input",
        "onUpdate:modelValue": t[1] || (t[1] = (l) => e.value = l),
        class: "b24-counter__input-control",
        type: "tel",
        disabled: u.isDisabled,
        onPaste: t[2] || (t[2] = n(() => {
        }, ["prevent"])),
        onBlur: t[3] || (t[3] = (...l) => s.onBlur && s.onBlur(...l)),
        onKeypress: t[4] || (t[4] = (...l) => s.valueMask && s.valueMask(...l)),
        onInput: t[5] || (t[5] = n((...l) => s.onInput && s.onInput(...l), ["prevent"])),
        onFocus: t[6] || (t[6] = (...l) => s.onFocus && s.onFocus(...l)),
        onKeyup: [
          t[7] || (t[7] = o((l) => s.onAction("plus"), ["up"])),
          t[8] || (t[8] = o((l) => s.onAction("minus"), ["down"]))
        ]
      }, null, 40, c), [
        [
          b,
          e.value,
          void 0,
          {
            trim: !0,
            number: !0
          }
        ]
      ])
    ]),
    a("button", {
      type: "button",
      class: "b24-counter__button _plus",
      disabled: e.value >= u.maxValue || u.isDisabled,
      onClick: t[9] || (t[9] = n((l) => s.onAction("plus"), ["prevent"]))
    }, " + ", 8, y)
  ], 2);
}
const x = /* @__PURE__ */ h(v, [["render", w]]);
export {
  x as default
};
